import { render, staticRenderFns } from "./SoundFileInput.vue?vue&type=template&id=1a113ca3&"
import script from "./SoundFileInput.vue?vue&type=script&lang=js&"
export * from "./SoundFileInput.vue?vue&type=script&lang=js&"
import style0 from "./SoundFileInput.vue?vue&type=style&index=0&id=1a113ca3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports